import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import RouterImage from '../../assets/imgs/router_img.svg';
import SearchImage from '../../assets/imgs/search.svg';
import ServerImage from '../../assets/imgs/server.svg';
import ChatImage from '../../assets/imgs/chat.svg';
import AlertImage from '../../assets/imgs/alert.svg';
import CloudPrivacyImage from '../../assets/imgs/cloud privacy.svg';
import SpyViewImage from '../../assets/imgs/spy view.svg';
import LoginImage from '../../assets/imgs/login.svg';

import DividerWithTitle from '../../components/DividerWithTitle';
import InfoWithImage from '../../components/InfoWithImage';
import ButtonSecondary from '../../design/button-secondary/ButtonSecondary';
import { useTranslation } from 'react-i18next';

const handleGetStarted = () => {
  const element = document.querySelector('#contact');
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};

export default function LandingInfoSecurityServices() {
  const { t } = useTranslation();

  const contactInfo = t('informationServices.services.servicesList', {
    returnObjects: true,
  }) as Array<{
    title: string;
    description: string;
  }>;

  const serviceIcons = [
    <AlertImage />,
    <SearchImage />,
    <CloudPrivacyImage />,
    <ChatImage />,
    <RouterImage />,
    <LoginImage />,
    <SpyViewImage />,
    <ServerImage />,
  ];

  return (
    <SecuritySection id='services'>
      <DividerWithTitle
        title={t('informationServices.services.dividerTitle')}
      />
      <SecurityContainer>
        <Typography
          textAlign={'center'}
          fontWeight={600}
          mb={4}
          color='primary.main'
          sx={{
            fontSize: { xs: '32px', sm: '40px', md: '60px' },
          }}
        >
          {t('informationServices.services.title')}
        </Typography>
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          flexWrap='wrap'
          sx={{
            gap: { xs: 2, md: 4 },
            justifyContent: { xs: 'center', md: 'space-between' },
          }}
        >
          {contactInfo.map((info, index) => (
            <InfoWithImage
              key={index}
              icon={serviceIcons[index]}
              title={info.title}
              description={info.description}
            />
          ))}
        </Box>
        <ButtonContainer>
          <ButtonSecondary onClick={handleGetStarted}>
            {t('informationServices.services.buttonText')}
          </ButtonSecondary>
        </ButtonContainer>
      </SecurityContainer>
    </SecuritySection>
  );
}

const SecuritySection = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  padding: '60px 86px',
  [theme.breakpoints.down('lg')]: {
    padding: '50px 40px',
  },
  [theme.breakpoints.down('md')]: {
    padding: '40px 24px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '30px 16px',
  },
}));

const SecurityContainer = styled(Box)(({ theme }) => ({
  maxWidth: '1370px',
  height: '100%',
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  paddingTop: '50px',
  [theme.breakpoints.down('md')]: {
    paddingTop: '30px',
  },
  [theme.breakpoints.down('sm')]: {
    paddingTop: '20px',
  },
}));

const ButtonContainer = styled(Box)(({ theme }) => ({
  width: '185px',
  paddingTop: theme.spacing(6),
  [theme.breakpoints.down('sm')]: {
    width: '100%',
    maxWidth: '300px',
  },
}));
